import { Form } from 'antd';
import MapInput from 'Components/Weaver/Input/MapInput';

export default function ({ form, field, value, ...props }) {
  return (
    <Form.Item
      label={_.startCase(field)}
      name={field + '-vars'}
      key={field + '-vars'}
    >
      <MapInput
        field={field + '-vars'}
        form={form}
        initialValue={Weaver.Attribute.withVarsMap(value)}
      />
    </Form.Item>
  )
}